import React, { useState } from 'react'
import config from 'config'
import { useSelector } from 'react-redux'
import Avatar from 'srcReact/components/common2/Avatar'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import NewConversation from '../NewConversation'
import { useTranslation } from 'react-i18next'
import ConversationList from '../ConversationList'
import MobileModal from 'srcReact/components/common2/MobileModal'

const Sidebar = ({
  isExpanded,
  isMobile,
  isDesktop,
  fromQuickMessenger,
  showBack = true,
  onToggle,
  showUserLightModal,
  setConversationId
}) => {
  const { t } = useTranslation()
  const [isNewConvOpen, setIsNewConvOpen] = useState(false)

  const {
    login: { user },
    messenger: { sidebarScreenType }
  } = useSelector((state) => state)

  return (
    <div className={styles.container}>
      {/* {isDesktop && (
        <React.Fragment>
          <div className={`${styles.profileContainer} ${!isExpanded && styles.profileContainerCollapsed} `}>
            {sidebarScreenType === 'search' && (
              <button
                type='button'
                className={styles.expandCollapse}
                onClick={onToggle}
                aria-label={isExpanded ? t('messenger.collapseSidebar') : t('messenger.expandSidebar')}>
                <Icon
                  name={isExpanded ? 'burger-collapse' : 'burger-expand'}
                  styleModifier={styles.expandCollapseIcon}
                />
              </button>
            )}
            <div
              className={`${styles.profileBg} ${!isExpanded && styles.collapsedProfileBg} ${
                isDesktop && isExpanded && sidebarScreenType === 'create' && styles.profileBgCreateConv
              }`}></div>
            {sidebarScreenType === 'search' && (
              <Avatar
                containerCSS={`${styles.profilePicture} ${!isExpanded && styles.profilePictureCollapsed}`}
                imgWrapperSize='medium'
                userId={user.id}
                profilePicture={user.profile_picture}
                firstname={user.firstname}
                lastname={user.lastname}
                onClickAction={() => showUserLightModal(user)}
                mimeType={user.mime_type}
                originalTag={user.original_tag}
                isOriginal={user.is_original}
              />
            )}
          </div>
          {isExpanded && sidebarScreenType === 'search' && (
            <React.Fragment>
              <div className={styles.links}>
                <a className={styles.link} tabIndex='0' href={`${config.webUrl + '/0/myhome'}`}>
                  <img src={config.assetUrl + '/images/myHome-icon.svg'} alt='' />
                  {t('sidebar.home')}
                </a>
                <a className={styles.link} tabIndex='0' href={`${config.webUrl + '/0/feed'}`}>
                  <img src={config.assetUrl + '/images/feed-icon.svg'} alt='' />
                  {t('sidebar.feed')}
                </a>
                <a className={styles.link} tabIndex='0' href={`${config.webUrl + '/0/calendar'}`}>
                  <img src={config.assetUrl + '/images/calendar-colored.svg'} alt='' />
                  {t('sidebar.calendar')}
                </a>
              </div>
              <div className={isExpanded ? styles.divider : styles.dividerCollapsed}></div>
            </React.Fragment>
          )}
        </React.Fragment>
      )} */}

      {sidebarScreenType === 'create' ? (
        isMobile ? (
          <MobileModal showBackArrow={false} isOpen={isNewConvOpen} showDraggableDiv={false} className='newConv'>
            <NewConversation
              deviceMode='mobile'
              showUserLightModal={showUserLightModal}
              isMobile={isMobile}
              setIsNewConvOpen={setIsNewConvOpen}
              setConversationId={setConversationId}
              fromQuickMessenger={fromQuickMessenger}
            />
          </MobileModal>
        ) : (
          <NewConversation
            deviceMode='desktop'
            isExpanded={isExpanded}
            showUserLightModal={showUserLightModal}
            isMobile={isMobile}
            setConversationId={setConversationId}
            fromQuickMessenger={fromQuickMessenger}
          />
        )
      ) : (
        <ConversationList
          isExpanded={isExpanded}
          isMobile={isMobile}
          isDesktop={isDesktop}
          fromQuickMessenger={fromQuickMessenger}
          setIsNewConvOpen={setIsNewConvOpen}
          showUserLightModal={showUserLightModal}
          showBack={showBack}
          setConversationId={setConversationId}
        />
      )}
    </div>
  )
}

export default Sidebar
